import type {Icon} from '@primer/octicons-react'
import type {ComponentProps, PropsWithChildren, ReactNode} from 'react'

import {BlankslateErrorMessage} from '../../../../components/error-boundaries/blankslate-error-message'
import styles from './base-chart-error.module.css'

interface MissingChartErrorProps extends Omit<ComponentProps<'div'>, 'content'> {
  icon?: Icon
  heading: ReactNode
  content: ReactNode
}

export const BaseChartError: React.FC<PropsWithChildren<MissingChartErrorProps>> = ({
  icon,
  heading,
  content,
  children,
  ...props
}) => {
  return (
    <div className={styles.Box} {...props}>
      <BlankslateErrorMessage icon={icon} heading={heading} content={content}>
        {children}
      </BlankslateErrorMessage>
    </div>
  )
}
